'use strict';
/* ==========================================================================
   core-local/hooks.js — "Federalists vs Anti-Federalists" (ratify): this lesson's hooks into the shared engine v2
   (shared/engine/v2/core/game.js reads window.LessonHooks). A copy of lessons/free-speech's (same cast, DESIGN.md §3).

   speakers: the name tag + colour of each voice in the portrait dock's captions (core/dock.js): Rex = brick red,
             Judge Okafor = navy ink (dark enough to read on the dock's paper).
   captions: fallback caption text + speaker for every line in content/script.json (segments + responses), so the
             video works before any voice is recorded. assets/vo/lines.json / who.json (what was recorded) win.
   completeCard(stepId, progress): (only the steps that stamp: the Pamphlet is a bonus, "stamp": false) the AMENDED card (DESIGN.md: the stamp word): the finished step's card.done + the
                          next step (below).
   Puppets (DESIGN.md §3): rex (poses rex, rex_point) stands LEFT, judge (judge, judge_point) stands RIGHT. The pose
            aliases resolve at DRAW time: the pointing cut-out when it is loaded, else the standing one (else the
            engine's paper stand-in). Facing (Puppet.NATIVE, as lessons/branches/assets/ASSETS.md): rex and judge face
            the front (0, never mirrored); rex_point points to the viewer's right (+1) and judge_point to the left (-1),
            so with Rex drawn facing +1 and the Judge -1 each points at the other.
   ========================================================================== */
window.LessonHooks = {
  speakers: { rex: { name: 'Rex', color: '#9e2b25' }, judge: { name: 'Judge O', color: '#1f2f55' } },
  /* lesson.json's steps[].card.next describes the step AFTER that step ("video" → "Next: Which Side?"), so the
     next line is the card.next of the step just before the first unratified one (the engine's default card reads the
     unratified step's own card.next, one step too far). */
  completeCard(stepId, progress) {
    const L = (window.Game && Game.lesson) || {}, steps = (L.steps || []).filter(s => s.stamp !== false), C = L.completeCard || {}, st = progress.stamps || {};
    const me = steps.find(s => s.id === stepId) || {};
    const done = (me.card && me.card.done) || 'Amended.';
    const k = steps.findIndex(s => !st[s.id]);
    let next;
    if (k < 0) next = C.allDone || 'All four amended!';
    else {
      const prev = steps[k - 1];
      next = prev && prev.card && prev.card.next && prev.id === stepId ? prev.card.next
        : `Next: ${steps[k].title || steps[k].id} (item ${k + 1}).`;
    }
    return { title: C.title || 'AMENDED', lines: [done, next] };
  },
  captions({ script, paper }) {
    const text = {}, who = {};
    const add = l => { text[l.id] = l.text; who[l.id] = l.who; };
    if (script) { script.segments.forEach(sg => (sg.lines || []).concat(sg.after || []).forEach(add)); (script.responses || []).forEach(add); }
    // the Pamphlet (content/paper.json, the bonus step): every voiced sentence, so its clips (vo/p*.wav) are known names
    // for the dev loader once the pamphlet tier lists them; assets/vo/paper_lines.json (what was recorded) wins in the step
    if (paper && typeof window !== 'undefined' && window.PaperReader) PaperReader.model(paper).seq.forEach(s => { text[s.id] = s.tts || s.text; who[s.id] = s.who; });
    return { text, who };
  },
};

/* the cast's poses (core/puppet.js: pose alias → image name; DEFAULT = the standing pose), resolved per draw */
(function () {
  const P = typeof window !== 'undefined' && window.Puppet;
  if (!P) return;                                   // node (tools/contentcheck.js reads only the speakers)
  const has = n => typeof IMG !== 'undefined' && !!IMG[n];
  // the first image that is loaded; the last name is the fallback (the engine draws a paper stand-in if it's missing too)
  const pick = (...names) => names.find(has) || names[names.length - 1];
  const poses = (me, point) => {
    const o = { [me]: me };
    Object.defineProperty(o, 'point', { enumerable: true, get: () => pick(point, me) });
    Object.defineProperty(o, point, { enumerable: true, get: () => pick(point, me) });
    return o;
  };
  P.POSES.rex = poses('rex', 'rex_point');
  P.POSES.judge = poses('judge', 'judge_point');
  P.DEFAULT.rex = 'rex';
  P.DEFAULT.judge = 'judge';
  Object.assign(P.NATIVE, { rex: 0, rex_point: 1, judge: 0, judge_point: -1 });
})();
